<div class="survey-popup">

  <div class="survey-popup__header">
    <img src="assets/images/JJMT_Icon_Web_Profile.svg" alt="J&J MedTech" class="survey-popup__brand-icon" />
    <button class="survey-popup__close-btn" (click)="onClose()" aria-label="Close">
      <span>&times;</span>
    </button>
  </div>

  <div class="survey-popup__body">
    <p class="survey-popup__status">STATUS: ACTION REQUIRED</p>
    <h2 class="survey-popup__title">We Value Your Feedback</h2>
    <p class="survey-popup__description">
      We are requesting your feedback for our application to help us improve your
      experience. Your insights directly influence our AI Advisor development roadmap.
    </p>
  </div>

  <div class="survey-popup__actions">
    <button
      class="survey-popup__btn survey-popup__btn--primary"
      (click)="onOpenSurvey()"
      [disabled]="isLoading">
      OPEN SURVEY &rarr;
    </button>

    @if (data.remind_buttons_visible) {
      <button
        class="survey-popup__btn survey-popup__btn--outline"
        (click)="onRemindLater()"
        [disabled]="isLoading">
        REMIND ME LATER
      </button>
      <button
        class="survey-popup__btn survey-popup__btn--outline"
        (click)="onRemindTomorrow()"
        [disabled]="isLoading">
        REMIND ME TOMORROW
      </button>
    } @else {
      <button
        class="survey-popup__btn survey-popup__btn--outline survey-popup__btn--opt-out"
        (click)="onOptOut()"
        [disabled]="isLoading">
        <span class="survey-popup__btn-label">NO LONGER REMIND ME</span>
        <span class="survey-popup__btn-note">This option becomes visible after clicking "Remind me later" 3 times</span>
      </button>
    }
  </div>

</div>
